//@ts-nocheck
import { useEffect, useState, createContext, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { fetchJobs } from '../store/slices/jobs/jobSlice';
import NotFound from '../pages/NotFound'; // Import your NotFound component

// Create context
const JobContext = createContext({
  jobDetailsData: null,
  loading: false,
  error: null,
});

// Custom hook for easy access
export const useJobData = () => useContext(JobContext);

// Provider component
const JobDataProvider = ({ children }) => {
  const { base_slug } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [jobDetailsData, setJobDetailsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showNotFound, setShowNotFound] = useState(false);

  useEffect(() => {
    if (!base_slug) {
      setShowNotFound(true);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      setShowNotFound(false);

      try {
        const res = await dispatch(fetchJobs(base_slug));
        const data = res.payload;

        // Check if the API returned an error response
        if (data && data.status && data.status === 404) {
          console.error('Base not found:', data.message);
          setShowNotFound(true);
          return;
        }

        // Check for the specific error message
        if (data && data.message === "Base not found") {
          console.error('Base not found:', data.message);
          setShowNotFound(true);
          return;
        }

        // Check if there's an error field in the response
        if (data && data.error) {
          console.error('API Error:', data.error);
          setShowNotFound(true);
          return;
        }

        // If we get here, the response is valid
        setJobDetailsData(data);

      } catch (err) {
        console.error("Error fetching job data", err);

        // Check if the error response contains our specific error
        if (err.response?.data?.message === "Base not found" ||
          err.response?.status === 404) {
          setShowNotFound(true);
        } else {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [base_slug, dispatch]);

  // If we need to show 404, render the NotFound component instead of children
  if (showNotFound) {    
    return <NotFound />;
  }

  // Show loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
        <div className="simple-spinner-loader">
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <JobContext.Provider value={{ jobDetailsData, loading, error, showNotFound }}>
      {children}
    </JobContext.Provider>
  );
};

export default JobDataProvider;